module.exports = __webpack_public_path__ + "static/media/target.68c002e2.svg";